import Component from '@glimmer/component';

import { registerDestructor } from '@ember/destroyable';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import EmberFlatpickr from 'ember-flatpickr/components/ember-flatpickr';

import datesConfig from 'rise-ui/config/dates.js';
import defaultHelper from 'rise-ui/helpers/default.js';
import nom from 'rise-ui/helpers/nom.js';
import update from 'rise-ui/modifiers/update.js';
import { diffDates, formatDate } from 'rise-ui/utils/date.js';
import { call } from 'rise-ui/utils/function.js';

const { formats } = datesConfig;

export default class TimeSeriesSelectionOutputDateComponent extends Component {
  @tracked commitOnBlur;

  picker;
  removePicker;
  editedDate;
  isEditing = false;

  constructor() {
    super(...arguments);
    registerDestructor(this, () => {
      this.removePicker?.();
    });
  }

  get selectedDate() {
    return this.picker?.selectedDates[0];
  }

  cacheEditedDate() {
    this.editedDate = this.selectedDate;
    this.isEditing = true;
  }

  commitDateFromPicker() {
    this.isEditing = false;
  }

  commitEditedDateToPicker() {
    setTimeout(() => {
      if (this.picker.isOpen || !this.isEditing) {
        return;
      }
      this.isEditing = false;
      const { editedDate, selectedDate } = this;
      const isDiff = selectedDate && editedDate
        ? diffDates(selectedDate, editedDate) : (!selectedDate !== !editedDate);
      if (isDiff) {
        this.picker.setDate(formatDate(selectedDate, 'picker'), true, formats.fromPicker);
      }
    });
  }

  @action
  onReady(selectedDates, dateStr, picker) {
    this.picker = picker;
    call(this.args.onReady, undefined, selectedDates, dateStr, picker);
    if (!this.commitOnBlur) {
      return;
    }
    const { input } = picker;
    const onFocus = () => this.cacheEditedDate();
    const onBlur = () => this.commitEditedDateToPicker();
    this.removePicker = () => {
      input.removeEventListener('focus', onFocus);
      input.removeEventListener('blur', onBlur);
    };
    input.addEventListener('focus', onFocus);
    input.addEventListener('blur', onBlur);
  }

  @action onChange(dates, ...args) {
    this.commitDateFromPicker();
    call(this.args.onChange, 0, this.selectedDate, ...args);
  }

  @action onClose() {
    this.commitEditedDateToPicker();
  }

  <template>
    {{defaultHelper this "commitOnBlur" @commitOnBlur true}}
    <span ...attributes>{{nom~}}
      <EmberFlatpickr
        placeholder="YYYY-MM-DD"
        @allowInput={{true}}
        @date={{@date}}
        @onReady={{this.onReady}}
        @onChange={{this.onChange}}
        @onClose={{this.onClose}}
        {{update this.cacheDate @date}}
      />{{nom~}}
    </span>
  </template>
}
